/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseShipmentPackage
 */
export interface ResponseShipmentPackage {
    /**
     * 
     * @type {number}
     * @memberof ResponseShipmentPackage
     */
    boxCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseShipmentPackage
     */
    boxHeight?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseShipmentPackage
     */
    boxLength?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseShipmentPackage
     */
    boxWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseShipmentPackage
     */
    boxWidth?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseShipmentPackage
     */
    shipNum?: string;
}

/**
 * Check if a given object implements the ResponseShipmentPackage interface.
 */
export function instanceOfResponseShipmentPackage(value: object): value is ResponseShipmentPackage {
    return true;
}

export function ResponseShipmentPackageFromJSON(json: any): ResponseShipmentPackage {
    return ResponseShipmentPackageFromJSONTyped(json, false);
}

export function ResponseShipmentPackageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseShipmentPackage {
    if (json == null) {
        return json;
    }
    return {
        
        'boxCount': json['box_count'] == null ? undefined : json['box_count'],
        'boxHeight': json['box_height'] == null ? undefined : json['box_height'],
        'boxLength': json['box_length'] == null ? undefined : json['box_length'],
        'boxWeight': json['box_weight'] == null ? undefined : json['box_weight'],
        'boxWidth': json['box_width'] == null ? undefined : json['box_width'],
        'shipNum': json['ship_num'] == null ? undefined : json['ship_num'],
    };
}

export function ResponseShipmentPackageToJSON(json: any): ResponseShipmentPackage {
    return ResponseShipmentPackageToJSONTyped(json, false);
}

export function ResponseShipmentPackageToJSONTyped(value?: ResponseShipmentPackage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'box_count': value['boxCount'],
        'box_height': value['boxHeight'],
        'box_length': value['boxLength'],
        'box_weight': value['boxWeight'],
        'box_width': value['boxWidth'],
        'ship_num': value['shipNum'],
    };
}

